import './Element'
import Modal from 'UI/modal'

const columns = [ {
    name: 'id',
    title: 'ID'
}, {
    name: 'name',
    title: 'Имя'
} ];
/**
 * Контрол для выбора значения из справочника в модальном окне (только для Data.Source)
 * В отличае от UI.Widget.Forms.Control.PopupSelect, возвращает данные в инпут
 * с возможностью дальнейшего редактирования и сохранения в виде текста
 * @class
 * @extends UI.Widget.Forms.Control.Element
 */
UI.Widget.Forms.Control.PopupInput = Class(UI.Widget.Forms.Control.Element, /** @lends UI.Widget.Forms.Control.PopupSelect.prototype */{
    $selectBtn: null,
    $removeBtn: null,
    $input: null,
    nullText: "[не выбрано]",
    titleKey: "title",
    valueKey: "value",
    template: "UI/Widget/Forms/Control/PopupInput/Control",
    windowTemplate: "UI/Widget/Forms/Control/PopupInput/Window",
    //itemTemplate: "UI/Widget/Forms/Control/PopupInput/Item",
    /** @type {ModalWindow} */
    popup: null,
    filter: {},
    //multiple: false,
    /** @type {Data.ServerSource} */
    ds: null,
    columns: [],
    /**
     * @protected
     */
    createElement() {
        var self = this;
        this.titleKey = this.$control.attr("title-key") || "title";
        this.valueKey = this.$control.attr("value-key") || "value";
        //this.multiple = this.$control.attr('multiple') != null;
        this.template = this.$control.attr('template') || this.template;
        //this.itemTemplate = this.$control.attr('item-template') || this.itemTemplate;

        this.windowTemplate = this.$control.attr('window-template') || this.windowTemplate;
        this.columns = this.$control.attr('columns') !== undefined ? JSON.parse(this.$control.attr('columns')) : [];
        this.ds = _.get(this.parent, this.$control.attr("source"));
        this.filter = this.$control.data("filter");

        if (_.isEmpty(this.columns)) {
            this.columns = [{
                name: this.valueKey
            }, {
                name: this.titleKey
            }];
        }

        this.$element = UI.Template.$render(this.template, {
            control: this
        });

        this.$selectBtn = this.$('.ctrl-psel-select');
        this.$removeBtn = this.$('.ctrl-psel-remove');
        this.$input = this.$('.ctrl-psel-template');

        const filterJson = this.$control.attr("filter");
        this.filter = filterJson ? JSON.parse(filterJson) : {};

        this.$selectBtn.click(::this.createPopup);
        this.$removeBtn.click(::this.reset);
        this.$element.on('click', '.ctrl-psel-item .remove', ::this.onRemoveClick);

        this.$input.keyup(function () {
            self.setValue(this.value);
        });
    },
    /**
     * @protected
     */
    removeElement() {
        this.destroyPopup();
        this.ParentCall();

        this.filter = {};
        this.columns = [];
        this.$selectBtn = this.$removeBtn = this.ds = null;
    },
    /**
     * @protected
     */
    _getFilter() {
        return this.filter;
    },
    /**
     * Grid initialization method.
     *
     * @return {UI.Widget.DataGridView}
     * @protected
     */
    createGrid() {
        const grid = this.grid = new UI.Widget.DataGridView(this.parent, {
            source: this.ds,
            gridLimit: 10,
            actions: null,
            columns: this.columns,
            filter: this._getFilter(),
            showHeader: false,
            createEnabled: false
        }).on("selectItem", ::this.onSelectItem);

        const value = this.getValue();

        /*grid.on('update', () => {
            if (!_.isEmpty(value)) {
                value.forEach(item => this.grid.selectItem(item, this.multiple ? 'multiple' : undefined));
            }
        });*/

        return grid;
    },
    /**
     * @protected
     */
    createPopup() {
        const grid = this.createGrid();

        grid.render();
        grid.reset();

        const $window = UI.Template.$render(this.windowTemplate);

        $window.find(".ctrl-psel-grid").append(grid.element);

        const $input = $window.find("input");

        const me = this;

        $input.keydown(function () {
            if (me.keyupTimeout_) {
                clearTimeout(me.keyupTimeout_);
            }

            me.keyupTimeout_ = setTimeout(/** @this HTMLInputElement */function () {
                if (me.oldValue_ != this.value) {
                    grid.filter = grid.filter || {};
                    grid.filter.pattern = this.value;

                    grid.reset();
                    me.oldValue_ = this.value;
                }
            }.bind(this), 200);
        });

        setTimeout(function () {
            $input.focus();
        }, 0);

        this.popup = new Modal({
            content: $window
        });
    },
    /**
     * @protected
     */
    destroyPopup() {
        this.grid && this.grid.destroy();
        this.popup && this.popup.close();
        this.popup = this.grid = null;
    },
    /**
     * @protected
     */
    reset() {
        this.setValue(null, true);
    },
    /**
     * @param {Object[]} value
     * @protected
     */
    updateElement(value) {
        this.$input.val(value);
        /*const $title = this.$('.ctrl-psel-items');

        if (_.isEmpty(value)) {
            $title.html(this.nullText);
            return;
        }

        $title.html(
            _.map(
                value || [],
                item => UI.Template.render(this.itemTemplate, {
                    control: this,
                    item
                })
            ).join('')
        );*/
    },

    /**
     * @param {{ item: Object }} evt
     * @protected
     */
    onSelectItem(evt) {
        var value = this.getValue() || '';
        this.setValue(value+'$'+evt.item.id+'$', true);
        this.destroyPopup();
    },

    /**
     * @param {Event} evt
     * @protected
     */
    onRemoveClick(evt) {
        const $btn = $(evt.target);
        const id = $btn.data('id');
        const value = this.getValue() || [];
        const reference = _.find(value, { id });

        if (reference) {
            _.remove(value, { id });
            this.setValue(value, true);
        }
    },

    editMode () {
        this.ParentCall()
        this.$('.ctrl-psel-template, .ctrl-psel-buttons, .remove').show()
    },
    viewMode () {
        this.ParentCall()
        this.$('.ctrl-psel-template, .ctrl-psel-buttons, .remove').hide()
    },
});
